import { AmountPicker } from "@src/features";
import { useSwapContext } from "@src/contexts";
import { useCallback, useEffect, useState } from "react";
import { SuccessView } from "../SuccessView";
import { ErrorView } from "../ErrorView";
import { useTokenBalance } from "@src/hooks";
import { Navigation, PageLayout } from "@src/components";
import { BackArrowIcon, CloseIcon } from "@src/assets";
import { RoutePath } from "@src/interfaces";
import { useNavigate } from "react-router-dom";

enum WithdrawState {
  Init = "Init",
  Success = "Success",
  Error = "Error",
}

export const WithdrawView = () => {
  const navigate = useNavigate();
  const [amount, setAmount] = useState("");
  const [withdrawState, setWithdrawState] = useState(WithdrawState.Init);
  const [showCloseButton, setShowCloseButton] = useState(false);
  const [showBackButton, setShowBackButton] = useState(true);
  const { cashToken, isFetchingBalances } = useSwapContext();
  const cashBalances = useTokenBalance({ token: cashToken });

  const withdraw = useCallback(() => {
    setWithdrawState(WithdrawState.Success);
  }, []);
  useEffect(() => {
    if (withdrawState === WithdrawState.Init) {
      setShowCloseButton(false);
      setShowBackButton(true);
    } else {
      setShowCloseButton(true);
      setShowBackButton(false);
    }
  }, [withdrawState]);
  return (
    <PageLayout
      navigation={
        <Navigation
          leftItems={[
            {
              content: showBackButton && <BackArrowIcon />,
              path: RoutePath.Wallet,
            },
            {
              content: "Withdraw",
              disabled: true,
              path: RoutePath.Withdraw,
            },
          ]}
          rightItems={
            showCloseButton
              ? [
                  {
                    content: <CloseIcon />,
                    onClick: () => navigate(RoutePath.Wallet),
                  },
                ]
              : []
          }
        />
      }
    >
      <>
        {withdrawState === WithdrawState.Init && (
          <AmountPicker
            amount={amount}
            setAmount={setAmount}
            maxAmount={Number(cashBalances.humanReadable)}
            balance={cashBalances.humanReadable}
            isBalanceLoading={isFetchingBalances}
            helperButtonsType="percentage"
          />
        )}
        {withdrawState === WithdrawState.Success && (
          <SuccessView title={"Withdraw successful "} amount={amount} />
        )}
        {withdrawState === WithdrawState.Error && (
          <ErrorView title={"Withdraw unsuccessful"} />
        )}
      </>
    </PageLayout>
  );
};
